import useGetPaymentMethodInitialValues from './useGetPaymentMethodInitialValues'

export default useGetPaymentMethodInitialValues
